import { CurrentLocationStatus } from '../../types/location';
import { currentLocationStatus } from '../../constants/error';
import { useEffect, useState } from 'react';
import {
  ErrorHeader,
  ErrorIconWrapper,
  ErrorInfo,
  ErrorInfoWrapper,
  RootContainer,
  StyledErrorIcon,
} from './LocationSelectErrorStyle';

export function LocationSelectError({ ...rest }) {
  const [currentLocation, setCurrentLocation] = useState<CurrentLocationStatus>(
    CurrentLocationStatus.NONE,
  );

  useEffect(() => {
    const subscription = currentLocationStatus.subscribe((e) => {
      setCurrentLocation(e);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (
    currentLocation === CurrentLocationStatus.NONE ||
    currentLocation === CurrentLocationStatus.ERROR ||
    currentLocation === CurrentLocationStatus.IS_LOADING
  ) {
    return <></>;
  }

  return (
    <RootContainer {...rest}>
      <ErrorIconWrapper>
        <StyledErrorIcon></StyledErrorIcon>
      </ErrorIconWrapper>
      <ErrorInfoWrapper>
        {currentLocation === CurrentLocationStatus.BAD_CURRENT_LOCATION && (
          <>
            <ErrorHeader>Location out of service area:</ErrorHeader>
            <ErrorInfo>
              Sorry, we&apos;re unable to provide service in your location at this time.
            </ErrorInfo>
          </>
        )}
        {currentLocation === CurrentLocationStatus.BROWSER_PERMISSION_NOT_GRANTED && (
          <>
            <ErrorHeader>Location access denied:</ErrorHeader>
            <ErrorInfo>
              To use the &apos;Current Location&apos; feature, please allow location access in your
              browser settings.
            </ErrorInfo>
          </>
        )}
      </ErrorInfoWrapper>
    </RootContainer>
  );
}
